import Swiper from 'swiper'

const homeSlideshow = document.querySelector('.home-slideshow .swiper-container') !== null;

if(homeSlideshow){
    let nbSlides = document.querySelectorAll('.home-slideshow .swiper-container .swiper-slide').length;
    let dataSlideAuto = document.querySelector('.home-slideshow .swiper-container').getAttribute('data-slide_auto');
    let dataSlideSpeed = document.querySelector('.home-slideshow .swiper-container').getAttribute('data-slide_speed');
    dataSlideSpeed = dataSlideSpeed + '000';

    let config = {
        effect : 'slide',
        grabCursor : 'true',
        speed: 700,
        loop : true,

        fadeEffect: {
            crossFade: true
        },

        keyboard: {
            enabled: true,
        },

        mousewheel: {
            forceToAxis: true,
            releaseOnEdges : true,
        },

        // Navigation (arrow)
        navigation: {
            nextEl: `.swiper-button-next`,
            prevEl: `.swiper-button-prev`,
        },

        // Pagination (bullet)
        pagination: {
            el: '.slideshow__pagination',
            type: 'bullets',
            clickable: true
        }
    }

    if(dataSlideAuto === '1'){
        config.autoplay = {
            delay: dataSlideSpeed,
            disableOnInteraction: false,
        }
    }

    if(nbSlides > 1) {
        let swiperHome = new Swiper('.home-slideshow .swiper-container', config);
    }
}


// Slider Posts
let postsSlides = document.querySelectorAll('.news .swiper-container .swiper-slide').length;

let postsConfig = {
    effect : 'slide',
    grabCursor : 'true',
    speed: 700,
    loop : true,
    slidesPerView: 'auto',

    fadeEffect: {
        crossFade: true
    },

    keyboard: {
        enabled: true,
    },

    mousewheel: {
        forceToAxis: true,
        releaseOnEdges : true,
    },

    navigation: {
        nextEl: `.news__navigation .swiper-button-next`,
        prevEl: `.news__navigation .swiper-button-prev`,
    },

    // // Default parameters
    // slidesPerView: 1,
    // spaceBetween: 20,
        
    // breakpoints: {

    //     1200: {
    //         slidesPerView:3,
    //         spaceBetween: 30
    //     },

    //     960: {
    //         slidesPerView: 3,
    //         spaceBetween: 20
    //     },

    //     640: {
    //         slidesPerView: 2,
    //         spaceBetween: 20
    //     }
    // }
}

if(window.innerHeight < 640 && postsSlides > 1) {
    let swiperPosts = new Swiper('.news .swiper-container', postsConfig);
} else if (window.innerHeight < 960 && postsSlides > 2) {
    let swiperPosts = new Swiper('.news .swiper-container', postsConfig);
} else if (postsSlides > 3) {
    let swiperPosts = new Swiper('.news .swiper-container', postsConfig);
}
